/**
 * Prefetch lazy route chunks before navigation (same import specifiers as HomePage React.lazy).
 * Safe to call repeatedly; duplicate network fetches are avoided by the browser/module cache.
 */

function prefetchOpcionesEditorDeferred(): void {
  const run = () => {
    void import("@/modules/Opciones/EditorComprobantes/EditorComprobantesSection").catch(() => {});
  };
  if (typeof requestIdleCallback !== "undefined") {
    requestIdleCallback(run, { timeout: 2500 });
  } else {
    setTimeout(run, 400);
  }
}

const routePrefetchers: Record<string, () => void> = {
  "/proveedores": () => {
    void import("@/modules/ProveedoresModule").catch(() => {});
  },
  "/clientes": () => {
    void import("@/modules/ClientesModule").catch(() => {});
  },
  "/ventas": () => {
    void import("@/modules/VentasModule").catch(() => {});
  },
  "/cheques": () => {
    void import("@/modules/ChequesModule").catch(() => {});
  },
  "/stock": () => {
    void import("@/modules/StockModule").catch(() => {});
  },
  "/articulos": () => {
    void import("@/modules/ArticulosModule").catch(() => {});
  },
  "/opciones": () => {
    void import("@/modules/OpcionesModule").catch(() => {});
    prefetchOpcionesEditorDeferred();
  },
  "/caja-bancos": () => {
    void import("@/modules/CajaBancosModule").catch(() => {});
  },
  "/presupuestos": () => {
    void import("@/modules/PresupuestosModule").catch(() => {});
  },
  "/fondos": () => {
    void import("@/modules/FondosModule").catch(() => {});
  },
  "/recibos": () => {
    void import("@/modules/RecibosModule").catch(() => {});
  },
  "/remitos-vtas": () => {
    void import("@/modules/RemitosVtasModule").catch(() => {});
  },
  "/reportes": () => {
    void import("@/modules/ReportesModule").catch(() => {});
  },
  "/iva": () => {
    void import("@/modules/IvaModule").catch(() => {});
  },
  "/pedidos": () => {
    void import("@/modules/PedidosModule").catch(() => {});
  },
  "/notifications": () => {
    void import("@/modules/NotificationsModule").catch(() => {});
  },
};

/**
 * @param route - e.g. "/ventas" or "/ventas?view=listado"
 */
export function prefetchModuleChunkByRoute(route: string): void {
  const base = route.split("?")[0] || route;
  if (base === "/opciones/editor-comprobantes" || base.startsWith("/opciones/editor-comprobantes/")) {
    void import("@/modules/OpcionesModule").catch(() => {});
    void import("@/modules/Opciones/EditorComprobantes/EditorComprobantesSection").catch(() => {});
    return;
  }
  const fn = routePrefetchers[base];
  if (fn) fn();
}
